export default __webpack_public_path__ + "static/media/auditor_2025.56bd8e4f.jpg";